module.exports = __webpack_public_path__ + "img/news-5.6158d34d.png";